import { useFormik } from 'formik';
import Link from 'next/link';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import { retrieveCSRFToken } from '../utils/ajax';
import InputField from '../components/form-fields/InputField';

const formSchema = Yup.object().shape({
  email: Yup.string().required()
});

const PasswordReset = () => {
  const formik = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: formSchema,
    onSubmit: async (params, { setSubmitting, setErrors }) => {
      const response = await fetch('/api-auth/password/reset/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': retrieveCSRFToken()
        },
        body: JSON.stringify(params)
      });

      const body = await response.json();

      if (response.status === 200) {
        const { detail } = body

        toast.success(detail);
        return;
      }

      const errors = Object.keys(body).reduce((acc, key) => {
        return { ...acc, [key]: body[key].join(" ") };
      }, {});
      setErrors(errors);
    }
  });

  return (
    <section className="section">
      <div className="container has-text-centered" style={{maxWidth: 480}}>
        <div className="_box p-6">
          <div className="">
            <h2 className="subtitle">Forgot your password?</h2>
            <p className="pb-2">We'll send you an email with instructions to reset it.</p>
          </div>

          <form onSubmit={formik.handleSubmit}>
            <InputField fieldName='email' label='' formik={formik} placeholder={'Your Email Address'} />

            <button type="submit" className="button is-success" disabled={formik.isSubmitting}>Reset Password</button>
          </form>

          <div className="has-text-centered mt-3">
            <small>Remembered your password? <Link href="/login/">Login</Link></small>
          </div>
        </div>
      </div>
    </section>
  )
};

export default PasswordReset;
